import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=3082b4a6&scoped=true&"
import script from "./CreateForm.vue?vue&type=script&lang=js&"
export * from "./CreateForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateForm.vue?vue&type=style&index=0&id=3082b4a6&prod&lang=scss&"
import style1 from "./CreateForm.vue?vue&type=style&index=1&id=3082b4a6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3082b4a6",
  null
  
)

export default component.exports